export default {
  instantReplyList: [],
  automationRules: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  messages: [],
  instantReply: {},
  replyStatistics: {
    total_delivered: 0,
    delivered_to: 0,
    total_clicked: 0,
    clicked_by: 0,
    links: [],
  },
  keywordAnalytics: {
    unique_interactions: {},
    all_interactions: {},
  },
  automationSettings: {},
  loadingInstantReplies: true,
  automationRulesLoaded: false,
  automationRuleSaved: false,
  automationRuleDeleted: false,
  instantReplySaved: false,
  instantReplyDeleted: false,
  instantReplyMessageDeleted: false,
  automationSettingsSaved: false,
  unsubscribeMessageSaved: false,
  uploadedFile: false,
  apiError: {},
  fileUploadError: {},
};
